import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  value: '14+',
  label: 'sources unified'
}, {
  value: '3.2M',
  label: 'signals / day'
}, {
  value: '<60s',
  label: 'to connect a source'
}, {
  value: '1',
  label: 'source of truth'
}];
export function StatsBand() {
  return <section className="bg-ink py-16 md:py-24" data-id="element-202">
      <div className="mx-auto max-w-[1200px] px-5 md:px-8" data-id="element-203">
        <div className="grid grid-cols-2 gap-y-12 md:grid-cols-4" data-id="element-204">
          {stats.map((s, i) => <motion.div key={s.label} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.08
        }} className="border-l border-cream/20 pl-5 md:pl-8" data-id="element-205">
              <div className="font-display text-6xl font-semibold leading-none text-cream md:text-7xl lg:text-8xl" data-id="element-206">
                {s.value}
              </div>
              <div className="mt-3 text-sm font-medium uppercase tracking-widest text-signal" data-id="element-207">
                {s.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}